import Vue from "vue";
import Router from "vue-router";
import store from "../store"; //引入store

Vue.use(Router);

const router = new Router({
  // mode: 'history',  //去掉url中的#
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: resolve => require(["@/pages/index"], resolve)
    },
    {
      path: "/qr-code",
      name: "qr-code",
      component: resolve => require(["@/pages/qr-code"], resolve)
    },
    {
      path: "/search",
      name: "search",
      component: resolve => require(["@/pages/search"], resolve)
    },
    // 公棚竞赛指定查询页面
    {
      path: "/assignmentQuery",
      name: "assignmentQuery",
      component: resolve => require(["@/pages/assignmentQuery"], resolve)
    },
    // H5/PC补缴凭证页面
    {
      path: "/replenishProof",
      name: "replenishProof",
      component: resolve => require(["@/pages/replenishProof"], resolve)
      // meta:{
      //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
      // },
    },
    // H5/PC招聘页面
    {
      path: "/recruitModule",
      name: "recruitModule",
      component: resolve => require(["@/pages/recruitModule"], resolve)
      // meta:{
      //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
      // },
    },
    {
      path: "/club-index", //俱乐部
      name: "club-index",
      component: resolve =>
        require(["@/pages/club-center/club-index"], resolve),
      redirect: {
        path: "/club-index/club-news"
      },
      children: [
        {
          path: "club-introduce", //俱乐部介绍
          name: "club-introduce",
          // component: resolve=>require(['@/pages/club-center/club-introduce'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "club-engineering", //六信工程介绍
          name: "club-engineering",
          // component: resolve=>require(['@/pages/club-center/club-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "club-notice", //俱乐部公告
          name: "club-notice",
          component: resolve =>
            require(["@/pages/club-center/club-notice"], resolve)
        },
        {
          path: "club-notice-detail", //俱乐部公告详情
          name: "club-notice-detail",
          component: resolve =>
            require(["@/pages/club-center/club-notice-detail"], resolve)
        },
        {
          path: "results-enquiry", //成绩查询
          name: "results-enquiry",
          component: resolve =>
            require(["@/pages/club-center/results-enquiry"], resolve)
        },
        {
          path: "results-enquiry-detail", //成绩查询详情
          name: "results-enquiry-detail",
          component: resolve =>
            require(["@/pages/club-center/results-enquiry-detail"], resolve)
        },
        {
          path: "club-album", //俱乐部相册
          name: "club-album",
          component: resolve =>
            require(["@/pages/club-center/club-album"], resolve)
        },
        {
          path: "club-album-detail", //俱乐部相册详情
          name: "club-album-detail",
          component: resolve =>
            require(["@/pages/club-center/club-album-detail"], resolve)
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls6",
          component: resolve =>
            require(["@/pages/club-center/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail6",
          component: resolve =>
            require(["@/pages/club-center/honour-halls-detail"], resolve)
        },
        {
          path: "charity-public", //俱乐部慈善公益
          name: "charity-public",
          component: resolve =>
            require(["@/pages/club-center/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //俱乐部慈善公益
          name: "charity-public-detail",
          component: resolve =>
            require(["@/pages/club-center/charity-public-detail"], resolve)
        },
        {
          path: "club-news", //最新动态
          name: "club-news",
          // component: resolve=>require(['@/pages/club-center/club-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "club-news-detail", //最新动态详情
          name: "club-news-detail",
          component: resolve =>
            require(["@/pages/club-center/club-news-detail"], resolve)
        },
        {
          path: "club-media", //俱乐部媒体中心
          name: "club-media",
          // component: resolve=>require(['@/pages/club-center/club-media'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "club-media-detail", //俱乐部媒体中心详情
          name: "club-media-detail",
          component: resolve =>
            require(["@/pages/club-center/club-media-detail"], resolve)
        },
        {
          path: "match-regulation", //赛事规程
          name: "match-regulation",
          component: resolve =>
            require(["@/pages/club-center/match-regulation"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "regulation-progress", //赛事规程详情
          name: "regulation-progress",
          component: resolve =>
            require(["@/pages/club-center/regulation-progress"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        }
      ]
    },
    // 【新】公棚（开尔大棚）
    {
      path: "/shed-index",
      name: "shed-index",
      component: resolve =>
        require(["@/pages/shed-column/shed-index"], resolve),
      redirect: {
        path: "/shed-index/shed-news"
      },
      children: [
        {
          path: "competition-list", //赛事列表
          name: "competition-list",
          component: resolve =>
            require(["@/pages/shed-column/competition-list"], resolve)
        },
        {
          path: "competition-detail", //赛事详情
          name: "competition-detail",
          component: resolve =>
            require(["@/pages/shed-column/competition-detail"], resolve)
          // meta: {
          //   requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "shed-introduce", //公棚介绍
          name: "shed-introduce",
          component: resolve =>
            require(["@/pages/shed-column/shed-introduce"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "shed-engineering", //公棚六信工程
          name: "shed-engineering",
          component: resolve =>
            require(["@/pages/shed-column/shed-engineering"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "shed-news", //公棚新闻
          name: "shed-news",
          component: resolve =>
            require(["@/pages/shed-column/shed-news"], resolve)
          // component: resolve => require(['@/components/common-page/news-list'], resolve),
        },
        {
          path: "shed-news-detail", //公棚新闻详情
          name: "shed-news-detail",
          component: resolve =>
            require(["@/pages/shed-column/shed-news-detail"], resolve)
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls",
          component: resolve =>
            require(["@/pages/shed-column/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail",
          component: resolve =>
            require(["@/pages/shed-column/honour-halls-detail"], resolve)
        }
      ]
    },
    // -------------------------------------
    {
      path: "/shed-index", //爱心公棚（开尔大棚）
      name: "shed-index",
      component: resolve =>
        require(["@/pages/public-shed/shed-index"], resolve),
      redirect: {
        path: "/shed-index/shed-news"
      },
      children: [
        {
          path: "shed-introduce", //公棚介绍
          name: "shed-introduce",
          // component: resolve=>require(['@/pages/public-shed/shed-introduce'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-engineering", //公棚六信工程
          name: "shed-engineering",
          // component: resolve=>require(['@/pages/public-shed/shed-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-notice", //公棚公告
          name: "shed-notice",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice"], resolve)
        },
        {
          path: "shed-notice-detail", //公棚公告详情
          name: "shed-notice-detail",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice-detail"], resolve)
        },
        {
          path: "shed-news", //公棚新闻
          name: "shed-news",
          // component: resolve=>require(['@/pages/public-shed/shed-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-news-detail", //公棚新闻详情
          name: "shed-news-detail",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "shed-media", //公棚媒体中心
          name: "shed-media",
          // component: resolve=>require(['@/pages/public-shed/shed-media'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-media-detail", //公棚媒体中心详情
          name: "shed-media-detail",
          component: resolve =>
            require(["@/pages/public-shed/shed-media-detail"], resolve)
        },
        {
          path: "match-regulation", //赛事规程
          name: "match-regulation1",
          component: resolve =>
            require(["@/pages/public-shed/match-regulation"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "regulation-progress", //赛事规程详情-正在进行
          name: "regulation-progress1",
          component: resolve =>
            require(["@/pages/public-shed/regulation-progress"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "match-reserve", //比赛预订
          name: "match-reserve",
          component: resolve =>
            require(["@/pages/public-shed/match-reserve"], resolve)
          // meta: {
          //   requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls1",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail1",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls-detail"], resolve)
        },
        {
          path: "results-enquiry", //成绩查询列表
          name: "results-enquiry1",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry"], resolve)
        },
        {
          path: "results-enquiry-detail", //成绩查询详情
          name: "results-enquiry-detail1",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry-detail"], resolve)
        },
        {
          path: "specify-query", //指定查询
          name: "specify-query",
          component: resolve =>
            require(["@/pages/public-shed/specify-query"], resolve)
        },
        {
          path: "shed-album", //公棚相册
          name: "shed-album",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "shed-album-detail", //公棚相册详情
          name: "shed-album-detail",
          component: resolve =>
            require(["@/pages/public-shed/shed-album-detail"], resolve)
        },
        {
          path: "videos", //爱心公棚-选择视频
          name: "videos",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "videos-album", //公棚相册
          name: "videos-album",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "videos-album-detail", //公棚相册详情
          name: "videos-album-detail",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },

        {
          path: "pictures", //爱心公棚-选择图片
          name: "pictures",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "pigeon-mien", //获奖鸽风采
          name: "pigeon-mien",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien"], resolve)
        },
        {
          path: "pigeon-mien-detail", //获奖鸽详情
          name: "pigeon-mien-detail",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien-detail"], resolve)
        },
        {
          path: "charity-public", //慈善公益
          name: "charity-public1",
          component: resolve =>
            require(["@/pages/public-shed/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //慈善公益详情
          name: "charity-public-detail1",
          component: resolve =>
            require(["@/pages/public-shed/charity-public-detail"], resolve)
        }
      ]
    },
    {
      path: "/shed-spring", //春棚
      name: "shed-spring",
      component: resolve =>
        require(["@/pages/public-shed/shed-spring"], resolve),
      redirect: {
        path: "/shed-spring/shed-news"
      },
      children: [
        {
          path: "shed-introduce", //公棚介绍
          name: "shed-introduce1",
          // component: resolve=>require(['@/pages/public-shed/shed-introduce'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-engineering", //公棚六信工程
          name: "shed-engineering1",
          // component: resolve=>require(['@/pages/public-shed/shed-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-notice", //公棚公告
          name: "shed-notice1",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice"], resolve)
        },
        {
          path: "shed-notice-detail", //公棚公告详情
          name: "shed-notice-detail1",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice-detail"], resolve)
        },
        {
          path: "shed-news", //公棚新闻
          name: "shed-news1",
          // component: resolve=>require(['@/pages/public-shed/shed-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-news-detail", //公棚新闻详情
          name: "shed-news-detail1",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "shed-media", //公棚媒体中心
          name: "shed-media1",
          // component: resolve=>require(['@/pages/public-shed/shed-media'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-media-detail", //公棚媒体中心详情
          name: "shed-media-detail1",
          component: resolve =>
            require(["@/pages/public-shed/shed-media-detail"], resolve)
        },
        {
          path: "match-regulation", //赛事规程
          name: "match-regulation2",
          component: resolve =>
            require(["@/pages/public-shed/match-regulation"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "regulation-progress", //赛事规程详情-正在进行
          name: "regulation-progress2",
          component: resolve =>
            require(["@/pages/public-shed/regulation-progress"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "match-reserve", //比赛预订
          name: "match-reserve1",
          component: resolve =>
            require(["@/pages/public-shed/match-reserve"], resolve)
          // meta: {
          //   requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls2",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail2",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls-detail"], resolve)
        },
        {
          path: "results-enquiry", //成绩查询列表
          name: "results-enquiry2",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry"], resolve)
        },
        {
          path: "results-enquiry-detail", //成绩查询详情
          name: "results-enquiry-detail2",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry-detail"], resolve)
        },
        {
          path: "specify-query", //指定查询
          name: "specify-query1",
          component: resolve =>
            require(["@/pages/public-shed/specify-query"], resolve)
        },
        {
          path: "shed-album", //公棚相册
          name: "shed-album1",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "shed-album-detail", //公棚相册详情
          name: "shed-album-detail1",
          component: resolve =>
            require(["@/pages/public-shed/shed-album-detail"], resolve)
        },
        {
          path: "videos", //春棚-选择视频
          name: "1",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "videos-album", //公棚相册
          name: "videos-album1",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "videos-album-detail", //公棚相册详情
          name: "videos-album-detail1",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "pictures", //春棚-选择图片
          name: "pictures1",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "pigeon-mien", //获奖鸽风采
          name: "pigeon-mien1",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien"], resolve)
        },
        {
          path: "pigeon-mien-detail", //获奖鸽详情
          name: "pigeon-mien-detail1",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien-detail"], resolve)
        },
        {
          path: "charity-public", //慈善公益
          name: "charity-public2",
          component: resolve =>
            require(["@/pages/public-shed/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //慈善公益详情
          name: "charity-public-detail2",
          component: resolve =>
            require(["@/pages/public-shed/charity-public-detail"], resolve)
        },
        {
          path: "awards-pigeon", //慈善公益详情
          name: "awards-pigeon",
          component: resolve =>
            require(["@/pages/public-shed/awards-pigeon"], resolve)
        }
      ]
    },
    {
      path: "/performance", //开尔赛绩
      name: "performance",
      component: resolve =>
        require(["@/pages/performance/race-performance"], resolve)
    },
    {
      path: "/race-performance-detail", //开尔赛绩
      name: "race-performance-detail",
      component: resolve =>
        require(["@/pages/performance/race-performance-detail"], resolve)
    },
    {
      path: "/welfare", //公益足迹
      name: "welfare",
      component: resolve =>
        require(["@/pages/performance/public-welfare"], resolve),
      redirect: {
        path: "/welfare/public-welfare"
      },
      children: [
        {
          path: "public-welfare",
          name: "public-welfare",
          // component: resolve=>require(['@/pages/public-shed/shed-introduce'],resolve),
          component: resolve =>
            require(["@/pages/performance/public-welfare"], resolve)
        }
      ]
    },
    {
      path: "/welfare-detail",
      name: "welfare-detail",
      component: resolve =>
        require(["@/pages/performance/welfare-detail"], resolve)
    },
    {
      path: "/shed-youth", //青年队
      name: "shed-youth",
      component: resolve =>
        require(["@/pages/public-shed/shed-index-youth"], resolve),
      redirect: {
        path: "/shed-youth/shed-news"
      },
      children: [
        {
          path: "shed-introduce", //公棚介绍
          name: "shed-introduce2",
          // component: resolve=>require(['@/pages/public-shed/shed-introduce'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-engineering", //公棚六信工程
          name: "shed-engineering2",
          // component: resolve=>require(['@/pages/public-shed/shed-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-notice", //公棚公告
          name: "shed-notice2",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice"], resolve)
        },
        {
          path: "shed-notice-detail", //公棚公告详情
          name: "shed-notice-detail2",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice-detail"], resolve)
        },
        {
          path: "shed-news", //公棚新闻
          name: "shed-news2",
          // component: resolve=>require(['@/pages/public-shed/shed-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-news-detail", //公棚新闻详情
          name: "shed-news-detail2",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "shed-media", //公棚媒体中心
          name: "shed-media2",
          // component: resolve=>require(['@/pages/public-shed/shed-media'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-media-detail", //公棚媒体中心详情
          name: "shed-media-detail2",
          component: resolve =>
            require(["@/pages/public-shed/shed-media-detail"], resolve)
        },
        {
          path: "match-regulation", //赛事规程
          name: "match-regulation3",
          component: resolve =>
            require(["@/pages/public-shed/match-regulation"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "regulation-progress", //赛事规程详情-正在进行
          name: "regulation-progress3",
          component: resolve =>
            require(["@/pages/public-shed/regulation-progress"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "match-reserve", //比赛预订
          name: "match-reserve2",
          component: resolve =>
            require(["@/pages/public-shed/match-reserve"], resolve)
          // meta: {
          //   requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls3",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail3",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls-detail"], resolve)
        },
        {
          path: "results-enquiry", //成绩查询列表
          name: "results-enquiry3",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry"], resolve)
        },
        {
          path: "results-enquiry-detail", //成绩查询详情
          name: "results-enquiry-detail3",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry-detail"], resolve)
        },
        {
          path: "specify-query", //指定查询
          name: "specify-query2",
          component: resolve =>
            require(["@/pages/public-shed/specify-query"], resolve)
        },
        {
          path: "shed-album", //公棚相册
          name: "shed-album2",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "videos", //青年队-选择视频
          name: "videos2",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "videos-album", //公棚相册
          name: "videos-album2",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "videos-album-detail", //公棚相册详情
          name: "videos-album-detail2",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "pictures", //青年队-选择图片
          name: "pictures2",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "shed-album-detail", //公棚相册详情
          name: "shed-album-detail2",
          component: resolve =>
            require(["@/pages/public-shed/shed-album-detail"], resolve)
        },
        {
          path: "pigeon-mien", //获奖鸽风采
          name: "pigeon-mien2",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien"], resolve)
        },
        {
          path: "pigeon-mien-detail", //获奖鸽详情
          name: "pigeon-mien-detail2",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien-detail"], resolve)
        },
        {
          path: "charity-public", //慈善公益
          name: "charity-public3",
          component: resolve =>
            require(["@/pages/public-shed/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //慈善公益详情
          name: "charity-public-detail3",
          component: resolve =>
            require(["@/pages/public-shed/charity-public-detail"], resolve)
        }
      ]
    },
    {
      path: "/shed-vanguard", //先锋队
      name: "shed-vanguard",
      component: resolve =>
        require(["@/pages/public-shed/shed-index-vanguard"], resolve),
      redirect: {
        path: "/shed-vanguard/shed-news"
      },
      children: [
        {
          path: "shed-introduce", //公棚介绍
          name: "shed-introduce3",
          // component: resolve=>require(['@/pages/public-shed/shed-introduce'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-engineering", //公棚六信工程
          name: "shed-engineering3",
          // component: resolve=>require(['@/pages/public-shed/shed-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "shed-notice", //公棚公告
          name: "shed-notice3",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice"], resolve)
        },
        {
          path: "shed-notice-detail", //公棚公告详情
          name: "shed-notice-detail3",
          component: resolve =>
            require(["@/pages/public-shed/shed-notice-detail"], resolve)
        },
        {
          path: "shed-news", //公棚新闻
          name: "shed-news3",
          // component: resolve=>require(['@/pages/public-shed/shed-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-news-detail", //公棚新闻详情
          name: "shed-news-detail3",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "shed-media", //公棚媒体中心
          name: "shed-media3",
          // component: resolve=>require(['@/pages/public-shed/shed-media'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "shed-media-detail", //公棚媒体中心详情
          name: "shed-media-detail3",
          component: resolve =>
            require(["@/pages/public-shed/shed-media-detail"], resolve)
        },
        {
          path: "match-regulation", //赛事规程
          name: "match-regulation4",
          component: resolve =>
            require(["@/pages/public-shed/match-regulation"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "regulation-progress", //赛事规程详情-正在进行
          name: "regulation-progress4",
          component: resolve =>
            require(["@/pages/public-shed/regulation-progress"], resolve)
          // meta:{
          //   requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "match-reserve", //比赛预订
          name: "match-reserve3",
          component: resolve =>
            require(["@/pages/public-shed/match-reserve"], resolve)
          // meta: {
          //   requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
          // },
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls4",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail4",
          component: resolve =>
            require(["@/pages/public-shed/honour-halls-detail"], resolve)
        },
        {
          path: "results-enquiry", //成绩查询列表
          name: "results-enquiry4",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry"], resolve)
        },
        {
          path: "results-enquiry-detail", //成绩查询详情
          name: "results-enquiry-detail4",
          component: resolve =>
            require(["@/pages/public-shed/results-enquiry-detail"], resolve)
        },
        {
          path: "specify-query", //指定查询
          name: "specify-query3",
          component: resolve =>
            require(["@/pages/public-shed/specify-query"], resolve)
        },
        {
          path: "shed-album", //公棚相册
          name: "shed-album3",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "shed-album-detail", //公棚相册详情
          name: "shed-album-detail3",
          component: resolve =>
            require(["@/pages/public-shed/shed-album-detail"], resolve)
        },
        {
          path: "videos", //先锋队-选择视频
          name: "videos3",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "videos-album", //公棚相册
          name: "videos-album3",
          component: resolve =>
            require(["@/pages/public-shed/shed-album"], resolve)
        },
        {
          path: "videos-album-detail", //公棚相册详情
          name: "videos-album-detail3",
          component: resolve =>
            require(["@/pages/public-shed/shed-news-detail"], resolve)
        },
        {
          path: "pictures", //先锋队-选择图片
          name: "pictures3",
          component: resolve =>
            require(["@/pages/public-shed/picture-video"], resolve)
        },
        {
          path: "pigeon-mien", //获奖鸽风采
          name: "pigeon-mien3",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien"], resolve)
        },
        {
          path: "pigeon-mien-detail", //获奖鸽详情
          name: "pigeon-mien-detail3",
          component: resolve =>
            require(["@/pages/public-shed/pigeon-mien-detail"], resolve)
        },
        {
          path: "charity-public", //慈善公益
          name: "charity-public4",
          component: resolve =>
            require(["@/pages/public-shed/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //慈善公益详情
          name: "charity-public-detail4",
          component: resolve =>
            require(["@/pages/public-shed/charity-public-detail"], resolve)
        }
      ]
    },
    {
      path: "/member-index", //会员中心
      name: "member-index",
      component: resolve =>
        require(["@/pages/member-center/member-index"], resolve),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: {
        path: "/member-index/account-info"
      },
      children: [
        {
          path: "account-info", //账号资料
          name: "account-info",
          component: resolve =>
            require(["@/pages/member-center/account-info"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "trajectory", //赛鸽轨迹
          name: "trajectory",
          component: resolve =>
            require(["@/pages/member-center/trajectory"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-pigeon", //我的赛鸽
          name: "my-pigeon",
          component: resolve =>
            require(["@/pages/member-center/my-pigeon"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-pigeon-detail", //我的赛鸽
          name: "my-pigeon-detail",
          component: resolve =>
            require(["@/pages/member-center/my-pigeon-detail"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "account-shed", //我的账户
          name: "account-shed",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-account", //我的账户
          name: "my-account",
          component: resolve =>
            require(["@/pages/member-center/my-account"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "slow-home", //迟归鸽
          name: "slow-home",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "late-return", //迟归鸽
          name: "late-return",
          component: resolve =>
            require(["@/pages/member-center/late-return"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-events", //我的赛事
          name: "my-events",
          component: resolve =>
            require(["@/pages/member-center/my-events"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "regulation-progress", //我的赛事详情
          name: "regulation-progress5",
          component: resolve =>
            require(["@/pages/member-center/regulation-progress"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "agent", //代理
          name: "agent",
          component: resolve =>
            require(["@/pages/member-center/agent"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "to-collect", //去收鸽
          name: "to-collect",
          component: resolve =>
            require(["@/pages/member-center/to-collect"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "shed-photos", //去入棚
          name: "shed-photos",
          component: resolve =>
            require(["@/pages/member-center/shed-photos"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-order", //我的预订
          name: "my-order",
          component: resolve =>
            require(["@/pages/member-center/my-order"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-appointment", //我的预约
          name: "my-appointment",
          component: resolve =>
            require(["@/pages/member-center/my-appointment"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "deliver-record", //交鸽记录
          name: "deliver-record",
          component: resolve =>
            require(["@/pages/member-center/deliver-record"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "order-list", //预约列表
          name: "order-list",
          component: resolve =>
            require(["@/pages/member-center/order-list"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "booking-pigeon", //预约交鸽
          name: "booking-pigeon",
          component: resolve =>
            require(["@/pages/member-center/booking-pigeon"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "agent-appointment", //代理收鸽
          name: "agent-appointment",
          component: resolve =>
            require(["@/pages/member-center/my-appointment"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "agent-pigeon", //预约收鸽
          name: "agent-pigeon",
          component: resolve =>
            require(["@/pages/member-center/agent-pigeon"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "cross-appointment", //代理交鸽
          name: "cross-appointment",
          component: resolve =>
            require(["@/pages/member-center/my-appointment"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "cross-pigeon", //预约交鸽
          name: "cross-pigeon",
          component: resolve =>
            require(["@/pages/member-center/cross-pigeon"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "voucher", //查看凭证
          name: "voucher",
          component: resolve =>
            require(["@/pages/member-center/voucher"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "match-reserve", //比赛预订
          name: "match-reserve4",
          component: resolve =>
            require(["@/pages/member-center/match-reserve"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "choice-shed", //预约探视-选择公棚
          name: "choice-shed",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "elite-event", //精英赛
          name: "elite-event",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "over-time", //加站赛
          name: "over-time",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "myEvents-detail", //比赛列表
          name: "myEvents-detail",
          component: resolve =>
            require(["@/pages/member-center/myEvents-detail"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "agent-greenhouse", //精英赛
          name: "agent-greenhouse",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "myPigeon", //精英赛
          name: "myPigeon",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "designated-game", //指定赛
          name: "designated-game",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "group-split", //团体分组
          name: "group-split",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "refund", //退费
          name: "refund",
          component: resolve =>
            require(["@/pages/member-center/choice-shed"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "my-refund", //退费表单
          name: "my-refund",
          component: resolve =>
            require(["@/pages/member-center/my-refund"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "choice-mode", //预约探视-选择方式
          name: "choice-mode",
          component: resolve =>
            require(["@/pages/member-center/choice-mode"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "classic-event", //精英赛
          name: "classic-event",
          component: resolve =>
            require(["@/pages/member-center/classic-event"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "registration-channel", //指定赛
          name: "registration-channel",
          component: resolve =>
            require(["@/pages/member-center/registration-channel"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "group-enrollment", //团体分组
          name: "group-enrollment",
          component: resolve =>
            require(["@/pages/member-center/group-enrollment"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: "overtime", //加站赛
          name: "overtime",
          component: resolve =>
            require(["@/pages/member-center/overtime"], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        }
      ]
    },
    {
      path: "/group-introduce", //鸽业介绍
      name: "group-introduce",
      component: resolve =>
        require(["@/pages/group-introduce/group-index"], resolve),
      redirect: {
        path: "/group-introduce/group-introduce"
      },
      children: [
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls",
          component: resolve =>
            require(["@/pages/group-introduce/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail",
          component: resolve =>
            require(["@/pages/group-introduce/honour-halls-detail"], resolve)
        },
        {
          path: "group-introduce", //鸽业介绍
          name: "group-introduce1",
          component: resolve =>
            require(["@/pages/group-introduce/group-introduce"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "brand-story", //品牌故事
          name: "brand-story",
          component: resolve =>
            require(["@/pages/group-introduce/brand-story"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "group-culture", //企业文化
          name: "group-culture",
          component: resolve =>
            require(["@/pages/group-introduce/group-culture"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "group-engineering", //集团六信工程
          name: "group-engineering",
          // component: resolve=>require(['@/pages/group-introduce/group-engineering'],resolve),
          component: resolve =>
            require(["@/components/common-page/introduce"], resolve)
        },
        {
          path: "group-notice", //集团公告
          name: "group-notice",
          component: resolve =>
            require(["@/pages/group-introduce/group-notice"], resolve)
        },
        {
          path: "group-notice-detail", //集团公告详情
          name: "group-notice-detail",
          component: resolve =>
            require(["@/pages/group-introduce/group-notice-detail"], resolve)
        },
        {
          path: "group-news", //开尔新闻
          name: "group-news",
          // component: resolve=>require(['@/pages/group-introduce/group-news'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "group-news-detail", //开尔新闻详情
          name: "group-news-detail",
          component: resolve =>
            require(["@/pages/group-introduce/group-news-detail"], resolve)
        },
        {
          path: "group-album", //集团相册
          name: "group-album",
          component: resolve =>
            require(["@/pages/group-introduce/group-album"], resolve)
        },
        {
          path: "group-album-detail", //集团相册详情
          name: "group-album-detail",
          component: resolve =>
            require(["@/pages/group-introduce/group-album-detail"], resolve)
        },
        {
          path: "charity-public", //集团 慈善公益
          name: "charity-public5",
          component: resolve =>
            require(["@/pages/group-introduce/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //集团 慈善公益
          name: "charity-public-detail5",
          component: resolve =>
            require(["@/pages/group-introduce/charity-public-detail"], resolve)
        }
      ]
    },
    {
      path: "/breeding-center", //育种中心
      name: "breeding-center",
      component: resolve =>
        require(["@/pages/breeding-center/breeding-index"], resolve),
      redirect: {
        path: "/breeding-center/breeding-introduce"
      },
      children: [
        {
          path: "breeding-introduce", //育种中心介绍
          name: "breeding-introduce",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-introduce"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "breeding-engineering", //育种中心六信工程
          name: "breeding-engineering",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-engineering"], resolve)
          // component: resolve => require(['@/components/common-page/introduce'], resolve),
        },
        {
          path: "breeding-notice", //育种中心公告
          name: "breeding-notice",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-notice"], resolve)
        },
        {
          path: "breeding-notice-detail", //育种中心公告详情
          name: "breeding-notice-detail",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-notice-detail"], resolve)
        },
        {
          path: "breeding-news", //最新动态
          name: "breeding-news",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-news"], resolve)
          // component: resolve => require(['@/components/common-page/news-list'], resolve),
        },
        {
          path: "breeding-news-detail", //最新动态详情
          name: "breeding-news-detail",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-news-detail"], resolve)
        },
        {
          path: "breeding-match1", //赛事分享-国内赛事
          name: "breeding-match1",
          // component: resolve=>require(['@/pages/breeding-center/breeding-match'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "breeding-match2", //赛事分享-欧洲赛事
          name: "breeding-match2",
          // component: resolve=>require(['@/pages/breeding-center/breeding-match'],resolve),
          component: resolve =>
            require(["@/components/common-page/news-list"], resolve)
        },
        {
          path: "breeding-match-detail", //赛事分享详情
          name: "breeding-match-detail",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-match-detail"], resolve)
        },
        {
          path: "breeding-match-detail2", //赛事分享详情
          name: "breeding-match-detail2",
          component: resolve =>
            require(["@/pages/breeding-center/breeding-match-detail"], resolve)
        },
        {
          path: "pigeon-appreciate", //铭鸽鉴赏
          name: "pigeon-appreciate",
          component: resolve =>
            require(["@/pages/breeding-center/pigeon-appreciate"], resolve)
        },
        {
          path: "pigeon-appreciate-detail", //铭鸽鉴赏详情
          name: "pigeon-appreciate-detail",
          component: resolve =>
            require([
              "@/pages/breeding-center/pigeon-appreciate-detail"
            ], resolve)
        },
        {
          path: "pigeon-share", //鸽经分享
          name: "pigeon-share",
          component: resolve =>
            require(["@/pages/breeding-center/pigeon-share"], resolve)
        },
        {
          path: "pigeon-share-detail", //鸽经分享详情
          name: "pigeon-share-detail",
          component: resolve =>
            require(["@/pages/breeding-center/pigeon-share-detail"], resolve)
        },
        {
          path: "honour-halls", //荣誉殿堂
          name: "honour-halls5",
          component: resolve =>
            require(["@/pages/breeding-center/honour-halls"], resolve)
        },
        {
          path: "honour-halls-detail", //荣誉殿堂详情
          name: "honour-halls-detail5",
          component: resolve =>
            require(["@/pages/breeding-center/honour-halls-detail"], resolve)
        },
        {
          path: "pair-list", //金牌配对
          name: "pair-list",
          component: resolve =>
            require(["@/pages/breeding-center/pair-list"], resolve)
        },
        {
          path: "pair-detail", //金牌配对详情
          name: "pair-detail",
          component: resolve =>
            require(["@/pages/breeding-center/pair-detail"], resolve)
        },
        {
          path: "charity-public", //慈善公益
          name: "charity-public6",
          component: resolve =>
            require(["@/pages/breeding-center/charity-public"], resolve)
        },
        {
          path: "charity-public-detail", //慈善公益详情
          name: "charity-public-detail6",
          component: resolve =>
            require(["@/pages/breeding-center/charity-public-detail"], resolve)
        }
      ]
    },
    {
      path: "/login", //登录
      name: "login",
      component: resolve => require(["@/pages/login"], resolve),
      meta: {
        page: "login"
      }
    },
    {
      path: "/register", //注册
      name: "register",
      component: resolve => require(["@/pages/register"], resolve),
      meta: {
        page: "login"
      }
    },
    {
      path: "/forget-pwd", //忘记密码
      name: "forget-pwd",
      component: resolve => require(["@/pages/forget-pwd"], resolve),
      meta: {
        page: "login"
      }
    },
    {
      path: "/app-chat", //app上用的客服
      name: "app-chat",
      component: resolve => require(["@/components/app-chat"], resolve)
    },
    {
      path: "/privacy-policy", //隐私政策
      name: "privacy-policy",
      component: resolve => require(["@/pages/privacy-policy"], resolve)
    },
    {
      path: "/video", //视频
      name: "video",
      component: resolve => require(["@/pages/video"], resolve)
    },
    {
      path: "/privacy-policy-app", //隐私政策-app
      name: "privacy-policy-app",
      component: resolve => require(["@/pages/privacy-policy-app"], resolve)
    },
    {
      path: "/service-policy", //服务政策
      name: "service-policy",
      component: resolve => require(["@/pages/service-policy"], resolve)
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = store.state.user.token;
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断该路由是否需要登录权限
    if (token) {
      // 判断当前的token是否存在 ； 登录存入的token
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else if (to.name == "login" && token) {
    next("/");
  } else {
    next();
  }
});

export default router;

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js